import styles from "./Containers.module.css";
import DataLabel from "../labels/DataLabel";

const PhotoPointCard = ({ selectedPhotoPoint }) => {
  let nameText = selectedPhotoPoint?.STRUCTURE_NAME
    ? selectedPhotoPoint.STRUCTURE_NAME
    : !selectedPhotoPoint?.SDE_TABLE
    ? "Greenfield Photo Point"
    : "N/A";

  const offsetMinutes = new Date().getTimezoneOffset();

  let lastEditedDate = new Date(
    Number(selectedPhotoPoint?.LAST_EDITED_DATE) + offsetMinutes * 60 * 1000
  );
  let createdDate = new Date(
    Number(selectedPhotoPoint?.CREATED_DATE) + offsetMinutes * 60 * 1000
  );

  return (
    <div className={styles.photoPointCard}>
      <DataLabel title={"Feature Name"} text={nameText} />
      {selectedPhotoPoint?.SDE_TABLE && (
        <DataLabel title={`Feature Type`} text={selectedPhotoPoint.SDE_TABLE} />
      )}
      {selectedPhotoPoint?.THREEGISID && (
        <DataLabel title={"THREEGISID"} text={selectedPhotoPoint.THREEGISID} />
      )}
      {selectedPhotoPoint?.ACCOUNTCODE && (
        <DataLabel
          title={"Account Code"}
          text={selectedPhotoPoint.ACCOUNTCODE}
        />
      )}
      {selectedPhotoPoint?.CREATED_USER && (
        <DataLabel
          title={"Created By"}
          text={selectedPhotoPoint.CREATED_USER}
        />
      )}
      {selectedPhotoPoint?.CREATED_DATE && (
        <DataLabel title={"Created Date"} text={`${createdDate}`} />
      )}
      {selectedPhotoPoint?.LAST_EDITED_USER && (
        <DataLabel
          title={"Last Edited By"}
          text={selectedPhotoPoint.LAST_EDITED_USER}
        />
      )}
      {selectedPhotoPoint?.LAST_EDITED_DATE && (
        <DataLabel title={"Last Edited Date"} text={`${lastEditedDate}`} />
      )}
    </div>
  );
};

export default PhotoPointCard;
